import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import ZamanAsimiPanel from "../../components/ZamanAsimiPanel";

export default function ZamanAsimiPage() {
    return (
        <div className="p-6 max-w-4xl">
            <div className="mb-6">
                <h1 className="font-display text-2xl text-white flex items-center gap-2">
                    <Clock className="h-6 w-6 text-[#D4AF37]" />
                    Zaman Aşımı Panosu
                </h1>
                <p className="text-sm text-slate-500 mt-1">
                    Alt durumda bekleyen dosyalar — 14 / 21 / 30+ gün uyarıları
                </p>
            </div>
            <ZamanAsimiPanel />
            <p className="text-xs text-slate-600 mt-4">
                Dosyaya gitmek için satıra tıklayın. Akıl brifing bu sayılarla uyumludur.
            </p>
        </div>
    );
}
